module.exports = __webpack_public_path__ + "img/11.6c64aab0.png";